import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscribers-comments',
  templateUrl: './subscribers-comments.component.html',
  styleUrls: ['./subscribers-comments.component.scss']
})
export class SubscribersCommentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
